import { Empty, Modal } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { CompanyProfileContext } from "../../../CustomContext";
import { getEmployees } from "../../../lib/getEmployees";
import CompanyView from "../company/CompanyView";
import EmployeeImporter from "./EmployeeImporter"; // Asegúrate de ajustar la ruta
import EmployeeTable from "./EmployeeTable";
import ModalGenerateInvoice from "./Invoice/ModalGenerateInvoice";
import RegisterEmployee from "./RegisterEmployee";

const EmployeeView = () => {
  const [open, setOpen] = useState(false);
  const [employeeList, setEmployeeList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isImporterOpen, setIsImporterOpen] = useState(false); // Estado para el modal del importador

  const { companyProfile } = useContext(CompanyProfileContext);
  const storage = JSON.parse(window.localStorage.getItem("userDetails"));

  useEffect(() => {
    if (
      companyProfile &&
      Object.keys(companyProfile).length > 0 &&
      companyProfile._id
    ) {
      getEmployees(companyProfile._id).then((res) => {
        setEmployeeList(res.data);
      });
    }
  }, [companyProfile]);
 
  const handleImportSuccess = () => {
    setIsImporterOpen(false); // Cerrar el modal de importación
    getEmployees(companyProfile._id).then((res) => {
      setEmployeeList(res.data); // Actualizar la tabla
    });
  };
  return (
    <>
      {storage.role === "admin" ? (
        <>
          <ToastContainer />
          <div
            id="history_wrapper"
            className="table-responsive dataTablehistory"
          >
            <div className="dataTables_wrapper no-footer">
              <div
                style={{
                  justifyContent: "space-between",
                  display: "flex",
                }}
              >
                <h3>Empleados afiliados</h3>
                <div>
                  <Link
                    to={"#"}
                    className="btn btn-primary"
                    onClick={() => {
                      setOpen(!open);
                    }}
                  >
                    + Nuevo
                  </Link>
                  {/* Botón para abrir el importador de empleados */}
                  <Link
                    to={"#"}
                    style={{ marginLeft: "10px" }}
                    className="ml-2 btn btn-info"
                    onClick={() => {
                      setIsImporterOpen(true); // Abre el modal del importador
                    }}
                  >
                    Importar Empleados
                  </Link>
                  <Link
                    to={"#"}
                    style={{ marginLeft: "10px" }}
                    className="ml-2 btn btn-warning"
                    onClick={() => {
                      setIsModalOpen(true);
                    }}
                  >
                    Facturar
                  </Link>
                </div>
              </div>
            </div>
          </div>
          
          {employeeList.length > 0 ? (
            <EmployeeTable
              data={employeeList}
              setEmployeeList={setEmployeeList}
            />
          ) : (
            <Empty
            style={{ marginTop: "10%" }}
            description="No hay empleados cargados."
            // image={Empty.PRESENTED_IMAGE_SIMPLE}
          />
          )}
          <RegisterEmployee
            setEmployeeList={setEmployeeList}
            openDrawer={open}
            setOpenDrawer={setOpen}
          />

          <ModalGenerateInvoice
            showModal={isModalOpen}
            setShowModal={setIsModalOpen}
            employeeList={employeeList}
          />

          {/* Modal para importar empleados */}
          <Modal
            title="Importar Empleados"
            open={isImporterOpen}
            onCancel={() => setIsImporterOpen(false)} // Cerrar el modal
            footer={null} // Sin footer
          >
            {/* Componente de importación de empleados */}
            <EmployeeImporter idCompany={companyProfile._id} onImportSuccess={handleImportSuccess} />
          </Modal>
        </>
      ) : (
        <CompanyView />
      )}
    </>
  );
};

export default EmployeeView;
